import { Container, createStyles, makeStyles } from '@material-ui/core';
import { usePreferredLocale } from '@sprinx/react-globalize';
import React, { FC } from 'react';
import {
  createApiClient,
  createInitialPropsRedirectToLogin,
  makeAfterComponent,
  wrapLayout,
} from '../../@sprinx/react-after-razzle';
import { AdminStaticContentDto, getAdminStaticPage } from '../../api/adminContent';
import ErrorInternal from '../../components/ErrorInternal';
import useTranslateWithFallback from '../../hooks/useTranslateWithFallback';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';
import commonThingsToLoad from '../../api/commonThingsToLoad';
import { DEFAULT_LOCALE } from '../../i18n/constants';

const useStyles = makeStyles(() =>
  createStyles<'root', {}>({
    root: {},
  }),
);

type StaticPageLayoutProps = {
  data: AdminStaticContentDto[];
};

const StaticPageLayout: FC<StaticPageLayoutProps> = ({ data }) => {
  const classes = useStyles();
  const t = useTranslateWithFallback();
  const locale = usePreferredLocale();
  const currectData = data.find((i) => i.locales?.includes(locale));

  return (
    <>
      <Container className={classes.root}>
        {currectData?.body ? (
          <div dangerouslySetInnerHTML={{ __html: currectData?.body ?? '' }} />
        ) : (
          <div>{t('app/dataIsNotAvailable')}</div>
        )}
      </Container>
    </>
  );
};
StaticPageLayout.displayName = 'StaticPageLayout';

type StaticPageProps = {
  data: AdminStaticContentDto[];
  error?: any;
};

const StaticPage: FC<StaticPageProps> = ({ error, data }) => {
  if (error) return <ErrorInternal error={error} />;
  return <StaticPageLayout data={data} />;
};

export default makeAfterComponent(wrapLayout(StaticPage, InfoLayout) as any, async ({ match, initialAppProps }) => {
  try {
    const { /* locale, */ group } = match.params;
    const locale = DEFAULT_LOCALE;
    const apiClient = createApiClient();
    const data = await getAdminStaticPage(apiClient, { locale, group });
    if (initialAppProps) {
      const appProps = initialAppProps;
      const apiClient = createApiClient({ accessToken: appProps.auth?.accessToken });
      const commonThings = await Promise.all(commonThingsToLoad.promises({ apiClient }));
      appProps.propagateToState({
        ...commonThingsToLoad.toRegister(commonThings),
      });
    }
    return { data, initialLocale: locale, group };
  } catch (error) {
    if (error.response?.status === 401) {
      return createInitialPropsRedirectToLogin({ match });
    }
    return { error };
  }
});
